import { render } from "./DeveloperForm.vue?vue&type=template&id=fd1d3348"
import script from "./DeveloperForm.vue?vue&type=script&lang=js"
export * from "./DeveloperForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__